export default __webpack_public_path__ + "static/media/testimonial-image5.e18f604e.jpeg";